import Ajax from '../common/ajax'
import ApiBase from './api-base'

export default {
  ...ApiBase,
  model: 'examImport',
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageLog`, queryParam)
  },
  getPageExam (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/pageExam`, queryParam)
  },
  importExamList (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/importExamList`, data)
  },
  importGradeCertificate (data) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/importGradeCertificate`, data)
  },
  getInfo (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listExamSubject/${id}`)
  },
  getTaskInfo (taskName) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/taskInfo/${taskName}`, {}, { showLoading: false })
  },
  getExamInfo (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/examineeInfo/${id}`)
  },
  editExam (data = {}) {
    return Ajax.put(`/api/gradeOrganization/v1/${this.model}/updateExam`, data)
  },
  getExamSubjectList (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listExamSubject/${id}`)
  },
  getGradeSubjectList (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listSubject/${id}`)
  },
  getSubjectGroupList (id) {
    return Ajax.get(`/api/gradeOrganization/v1/${this.model}/listSubjectGroup/${id}`)
  },
  addExamSubject (data = {}) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/addExamSubject`, data)
  },
  editExamSubject (data = {}) {
    return Ajax.put(`/api/gradeOrganization/v1/${this.model}/updateExamSubject`, data)
  },
  exportExcel (data = {}) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/exportExamList`, data)
  },
  delExamBatch (ids) {
    return Ajax.post(`/api/gradeOrganization/v1/${this.model}/deleteExam`, ids)
  },
  getTemporary (id) {
    return Ajax.get(`/api/gradeOrganization/v1/examinee/temporaryPwd/${id}`)
  }
}
